// textBoxManager.js
import TextBox from "./textBox";
import workspace from "../workspace";

class TextBoxManager {
  constructor() {
    this.textBoxes = [];
  }

  getExportedTextBoxes = () => {
    return this.textBoxes.map(box => box.export());
  };

  setImportedTextBoxes = (_textBoxes) => {
    if (_textBoxes === undefined) {
      return []
    }
    for (let i = 0; i < _textBoxes.length; i++) {
      let textBox = new TextBox(_textBoxes[i].posOnField, _textBoxes[i].placeholder, _textBoxes[i].design);
      textBox.init();
    }

    return this.textBoxes;
  };

  getTextBoxes = () => {
    return this.textBoxes;
  };

  getHoveredTextBox = () => {

  }

  addTextBox = (box) => {
    this.textBoxes.push(box);

    return this.textBoxes;
  };

  removeBox = (box) => {
    let boxes = this.textBoxes.map((textBox => textBox.box));
    const index = boxes.indexOf(box);
    if (index > -1) {
      this.textBoxes.splice(index, 1);
    }

    return this.textBoxes;
  };

  removeAllTextBoxes = () => {
    for (let i = this.textBoxes.length - 1; i >= 0; i--) {
      this.textBoxes[i].box.delete();
      //textBoxes[i].text.delete();
    }
    this.textBoxes = [];

    return this.textBoxes;
  };

  getTextBoxPointsOnWorkspace = () => {
    const textBoxPointsOnWorkspace = [];
    this.textBoxes.forEach(textBox => {
      const boxPosition = textBox.getPosition();
      const height = textBox.box.height;
      const width = textBox.box.width;

      textBoxPointsOnWorkspace.push({x: boxPosition.x + width, y: boxPosition.y});
      textBoxPointsOnWorkspace.push({x: boxPosition.x + width, y: boxPosition.y + height});
      textBoxPointsOnWorkspace.push(boxPosition);
    })

    return textBoxPointsOnWorkspace
  }

  isBoxActive() {
    const boxes = workspace.textBoxManager.getTextBoxes();

    if (boxes.length > 0) {
      for (let textBox of boxes) {
        if (textBox.box.mixin.movable.state.hovering
          || textBox.box.mixin.movable.state.hoveringWithChildren
        ) {
          return true;
        }
      }
    }

    return false;
  }

  getHoveredTexBox() {
    const boxes = workspace.textBoxManager.getTextBoxes();

    if (boxes.length > 0) {
      for (let textBox of boxes) {
        if (textBox.box.mixin.movable.state.hovering) {
          return textBox;
        }
      }
    }

    return false;
  }

}

export default TextBoxManager;
